import { useMutation } from "@apollo/client/react";
import { DELETE_RISK_SCORE_ADJUSTMENT } from "../../mutations/aml/deleteRiskScoreAdjustment";
import GET_CLIENT_RISK_SCORE from "../../queries/aml/getClientRiskScore";

export const useDeleteRiskScoreAdjustment = ({ onCompleted, onError }: any) => {
  const [deleteRiskScoreAdjustment, { data, loading, error }] = useMutation(
    DELETE_RISK_SCORE_ADJUSTMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENT_RISK_SCORE],
      awaitRefetchQueries: true,
    }
  );

  return { deleteRiskScoreAdjustment, data, loading, error };
};
